import React from 'react'
import { getTranslation } from '../translations'

export default function Disclaimer({ language = 'english' }) {
  const t = getTranslation(language)
  
  return (
    <div className="mt-8">
      <h2 className="text-xl font-extrabold text-[#134225] text-center">{t.disclaimer}</h2>
      <div className="max-w-5xl mx-auto mt-8 text-gray-700 leading-7 text-sm">
        <p>{t.disclaimerText}</p>
      </div>
    </div>
  )
}
